import { render, staticRenderFns } from "./paramnew.vue?vue&type=template&id=1e77f9f0&scoped=true&"
import script from "./paramnew.vue?vue&type=script&lang=js&"
export * from "./paramnew.vue?vue&type=script&lang=js&"
import style0 from "./paramnew.vue?vue&type=style&index=0&lang=less&"
import style1 from "./paramnew.vue?vue&type=style&index=1&id=1e77f9f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e77f9f0",
  null
  
)

export default component.exports